<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <path d="M10.011,20.76c0,1.099,0.891,1.99,1.99,1.99c1.099,0,1.99-0.891,1.99-1.99H10.011z M12.001,5.75c2.761,0,5,2.239,5,5v7h-10
     v-7c0-2.761,2.238-4.999,4.999-5H12.001z M12.001,1.25c-0.828,0-1.5,0.672-1.5,1.5v1.17c-3.21,0.702-5.499,3.544-5.5,6.83v6l-2,2v1
     h18v-1l-2-2v-6c-0.001-3.286-2.29-6.128-5.5-6.83V2.75C13.501,1.922,12.829,1.25,12.001,1.25c0,0-0.001,0-0.001,0H12.001z"/>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'notifications'
}
</script>
